export class BatteryStatusService {
    batteryStatus = null;
    alertedLow = false;
    alertedCritical = false;
    static PERCENT_LOW = 20;
    static PERCENT_CRITICAL = 5;
    $translate;
    notificationService;
    log;
    static $inject = ['$translate', 'LogService', 'NotificationService'];
    constructor($translate, logService, notificationService) {
        this.$translate = $translate;
        this.notificationService = notificationService;
        this.log = logService.getLogger('BatteryStatus-S');
    }
    setStatus(batteryStatus) {
        this.log.debug('Status:', batteryStatus);
        if (batteryStatus.percent === null) {
            this.clearStatus();
            return;
        }
        this.batteryStatus = batteryStatus;
        if (!batteryStatus.isCharging) {
            if (!this.alertedCritical && batteryStatus.percent < BatteryStatusService.PERCENT_CRITICAL) {
                this.notifyLevel('critical');
                this.alertedCritical = true;
            }
            else if (!this.alertedLow && batteryStatus.percent < BatteryStatusService.PERCENT_LOW) {
                this.notifyLevel('low');
                this.alertedLow = true;
            }
        }
        if (this.alertedLow && batteryStatus.isCharging) {
            this.alertedLow = false;
            this.notificationService.hideNotification('battery-low');
        }
        if (this.alertedCritical && batteryStatus.isCharging) {
            this.alertedCritical = false;
            this.notificationService.hideNotification('battery-critical');
        }
        const hysteresis = 3;
        if (this.alertedLow && batteryStatus.percent > BatteryStatusService.PERCENT_LOW + hysteresis) {
            this.alertedLow = false;
            this.notificationService.hideNotification('battery-low');
        }
        if (this.alertedCritical && batteryStatus.percent > BatteryStatusService.PERCENT_CRITICAL + hysteresis) {
            this.alertedCritical = false;
            this.notificationService.hideNotification('battery-critical');
        }
    }
    clearStatus() {
        this.batteryStatus = null;
    }
    get dataAvailable() {
        return this.batteryStatus !== null;
    }
    get percent() {
        return this.batteryStatus.percent;
    }
    get isCharging() {
        return this.batteryStatus.isCharging;
    }
    get isLow() {
        return this.batteryStatus.percent < BatteryStatusService.PERCENT_LOW;
    }
    get isCritical() {
        return this.batteryStatus.percent < BatteryStatusService.PERCENT_CRITICAL;
    }
    notifyLevel(level) {
        if (!this.notificationService.getWantsNotifications()) {
            return;
        }
        const title = this.$translate.instant('common.WARNING');
        const picture = 'img/ic_battery_alert-64x64.png';
        let tag;
        let body;
        if (level === 'low') {
            tag = 'battery-low';
            body = this.$translate.instant('battery.LEVEL_LOW', { percent: this.percent });
            this.notificationService.hideNotification('battery-critical');
        }
        else if (level === 'critical') {
            tag = 'battery-critical';
            body = this.$translate.instant('battery.LEVEL_CRITICAL', { percent: this.percent });
            this.notificationService.hideNotification('battery-low');
        }
        this.notificationService.showNotification(tag, title, body, picture, undefined, true, true);
    }
    toString() {
        if (this.batteryStatus === null) {
            return 'No data';
        }
        return this.percent + '%, ' + (this.isCharging ? 'charging' : 'discharging');
    }
}
